import { IsNotEmpty, MaxLength } from "class-validator";
import Spec from "constants/Spec";
import { PlanType } from "types/enum/PlanType";

export default class UpdateCompanyGroupReq {
  @IsNotEmpty({
    message: "",
  })
  readonly companyGroupId: number;

  @MaxLength(Spec.maxLength.company.name, {
    message: "",
    context: {
      constraint1: Spec.maxLength.company.name,
    },
  })
  @IsNotEmpty({ message: "" })
  name!: string;

  @MaxLength(Spec.maxLength.company.kana, {
    message: "",
    context: {
      constraint1: Spec.maxLength.company.kana,
    },
  })
  @IsNotEmpty({ message: "" })
  kana!: string;

  @IsNotEmpty({ message: "" })
  plan!: PlanType;

  /**
   * 離脱判定の窓（日）。空欄なら既定（90 日）。
   *
   * 型を任意にしてある理由
   *   2026-08-26 …必須にしたら Payment/index.tsx の 2 箇所が落ちた。
   *   あちらは この項目を持たない物を そのまま渡している。
   *   任意にしておけば あちらは送らず、サーバーが「触らない」と読む。
   *   必須にすると あちらが空を送り、設定が消える ── だから任意が正しい。
   *
   * 値を数へ直しているのは この class ではない。
   *   FormModal は Object.assign(new updateType(), {...formData}) で作るので、
   *   コンストラクタは引数なしで呼ばれる。ここに書いた変換は走らない。
   *   実際に数へ直しているのは FormField の FormType.Number
   *   （components/FormField.tsx:212）。
   *
   * 空欄で既定へ戻す道は まだ通っていない（2026-08-26 時点）
   *   FormField:212 の条件が `a === b || c || d` の形で、
   *   undefined と "" が条件になっていない。空欄が 0 になる。
   *   サーバーは 1〜3650 で弾くので、空欄では保存できない。
   *   FormType.Number は 66 箇所で使われているので、
   *   その直しは 影響を見た上で 別に出す。
   */
  guestActiveWindowDays?: number | null;

  constructor(arg: any) {
    arg = arg || {};
    this.companyGroupId = arg.companyGroupId;
    this.name = arg.name;
    this.kana = arg.kana;
    this.plan = arg.plan;
    // guestActiveWindowDays はここで触らない。
    //   FormModal が Object.assign で後から入れるので、
    //   ここで既定を入れると 入れた値を上書きしてしまう。
  }
}
